import { CustomAnswer, CustomQuestion, CustomQuestionVisibility } from '../store/events/interfaces'

/**
 * Checks whether a custom question should be shown in the registration frontend based on its visibility.
 */
export const isQuestionVisibleInFrontend = (
  question: CustomQuestion | { visibility: CustomQuestionVisibility | string }
): boolean => {
  return (
    question.visibility === CustomQuestionVisibility.REGISTRATION_ONLY ||
    question.visibility === CustomQuestionVisibility.PASS_AND_REGISTRATION
  )
}

// Alias for backward compatibility
export const isSupportedCustomQuestion = isQuestionVisibleInFrontend

export const filterCustomQuestions = (
  questions: CustomQuestion[] | undefined
): CustomQuestion[] => {
  if (!questions) return []
  return questions.filter(isQuestionVisibleInFrontend)
}

export const filterCustomAnswers = (
  answers: CustomAnswer[] | undefined,
  questions?: CustomQuestion[]
): CustomAnswer[] => {
  if (!answers) return []
  return answers.filter((a) => {
    if (questions) {
      const matchedQuestion = questions.find((q) => q.id === a.question_id)
      if (matchedQuestion) {
        return isQuestionVisibleInFrontend(matchedQuestion)
      }
    }
    return false
  })
}
